import { privacyDocumentSchema } from 'app/src/msw/membership/schemas/privacyDocument'
import { signatureSchema } from 'app/src/msw/membership/schemas/signature'
import { UserFamilyMember } from 'app/src/services/welfareportal'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const familyMembersSchema: z.ZodType<UserFamilyMember> = z.object({
  familyMemberId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  fiscalCode: z.string(),
  taxDependent: z.boolean(),
  relationship: z.enum([
    'coniuge',
    'fratello_sorella',
    'figlio_figlia',
    'genero_nuora',
    'suocero_suocera',
    'genitore',
    'genitore_convivente',
    'genitore_percettore',
    'ascendente',
    'figlio_figlia_coniuge_deceduto',
    'discendente_prossimo',
  ]),
  allowEditing: z.boolean().optional(),
  privacyDocument: privacyDocumentSchema.optional(),
  signature: signatureSchema,
})
